import { ButtonType, ButtonWidget, InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import { Formik, FormikProps } from 'formik';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FormikTextBox } from '~src/commonInfra/components/FormikField';
import WebHttpClient from '~src/httpClient/WebHttpClient';

import { ActivityLogVerifySecurityFileRequest } from '../serverApi/requests/ActivityLogVerifySecurityFileRequest';
import { ActivityLogSecurityVerificationFile,ISiteCEPPStatusResult } from '../serverApi/types/IActivityLog';
import { activityLogConnectionSetupTextFieldSize, activityLogFileVerificationInput, activityLogFileVerificationInputLabel, activityLogVerificationContainer, activityLogVerificationPadding, activityLogVerificationRow } from '../styles/ActivityLogSettingsStyles';
import { ACTIVITY_LOG } from './ActivityLogSettings';

export interface ActivityLogSecurityFileVerificationProps {
    updateStatusCallback: (newStatus: ISiteCEPPStatusResult) => void;
}

export function ActivityLogSecurityFileVerification(props: ActivityLogSecurityFileVerificationProps) {
    return <div>
        <InlineAlertWidget
            children={ActivityLogSecurityFileVerificationInput(props)}
            type={InlineAlertType.Warning}
            testId={`${ACTIVITY_LOG}-verification-file`}
        />
    </div>;
}

function submitSecurityFileContent(updateStatusCallback: (newStatus: ISiteCEPPStatusResult) => void, content: string) {
    WebHttpClient.sendRequest(new ActivityLogVerifySecurityFileRequest({fileContent: content})).then((result: ISiteCEPPStatusResult) => {
        if (result && result.siteCEPPConfiguration) {
            updateStatusCallback(result);
        }
    });
}

function ActivityLogSecurityFileVerificationInput(props: ActivityLogSecurityFileVerificationProps) {
    return <Formik
        initialValues={{fileContent: ''}}
        onSubmit={(value: ActivityLogSecurityVerificationFile) => {
            submitSecurityFileContent(props.updateStatusCallback, value.fileContent);
        }}>
        {(formik: FormikProps<ActivityLogSecurityVerificationFile>) => (
            <div>
                <span>
                    <form name='securityFileVerificationForm' autoComplete='off' noValidate onSubmit={formik.handleSubmit} data-tb-test-id={`${ACTIVITY_LOG}-security-verification-form`}>
                        <div className={activityLogVerificationRow}>
                            <div className={activityLogVerificationContainer}>
                                <div className={activityLogVerificationPadding}>
                                    {Messages.activityLogSecurityFileVerificationDescription()}
                                </div>
                                <div className={activityLogFileVerificationInputLabel}>
                                    {Messages.activityLogSecurityFileVerification()}
                                </div>
                                <FormikTextBox
                                    className={activityLogFileVerificationInput}
                                    testId={`${ACTIVITY_LOG}-verification-file-input`}
                                    label={''}
                                    name='fileContent'
                                    size={activityLogConnectionSetupTextFieldSize}
                                    tabIndex={0}
                                    placeholder={''}
                                    disableOnSubmit={false}
                                />
                                <ButtonWidget
                                    buttonType={ButtonType.Primary}
                                    tabIndex={0}
                                    style={{marginLeft: '10px'}}
                                    testId={`${ACTIVITY_LOG}-verification-file-btn`}
                                    disabled={!formik.values.fileContent}>
                                        {Messages.submit()}
                                </ButtonWidget>
                            </div>
                        </div>
                    </form>
                </span>
            </div>
        )}
    </Formik>;
}
